import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const createEventSelector = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.entities.events.byId[id];

export const createEventsSelector = (ids: string[]) =>
  createSelector(...ids.map(createEventSelector), (...events) => events.filter((item) => item !== undefined));
